var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	4606: () => (loadSingletonVersion("default", "@angular/core", false, [1,17,3,0], () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(/*! @angular/core */ 7580))))))),
	5880: () => (loadSingletonVersion("default", "@angular/common", false, [1,17,3,0], () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(/*! @angular/common */ 316))))))),
	2115: () => (loadSingletonVersion("default", "@angular/cdk/platform", false, [1,17,3,10], () => (__webpack_require__.e(80).then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 7699))))))),
	2931: () => (loadSingletonVersion("default", "@angular/cdk/keycodes", false, [1,17,3,10], () => (__webpack_require__.e(4879).then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 4879))))))),
	5065: () => (loadSingletonVersion("default", "@angular/cdk/coercion", false, [1,17,3,10], () => (__webpack_require__.e(2814).then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))))),
	5883: () => (loadSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (__webpack_require__.e(845).then(() => (() => (__webpack_require__(/*! rxjs */ 845))))))),
	6597: () => (loadSingletonVersion("default", "@angular/cdk/layout", false, [1,17,3,10], () => (__webpack_require__.e(5531).then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 7912))))))),
	6883: () => (loadSingletonVersion("default", "rxjs/operators", false, [2,7,8,0], () => (__webpack_require__.e(8219).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 8219))))))),
	7139: () => (loadSingletonVersion("default", "@angular/cdk/observers", false, [1,17,3,10], () => (__webpack_require__.e(1920).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 9539))))))),
	1839: () => (loadSingletonVersion("default", "@angular/cdk/overlay", false, [1,17,3,10], () => (__webpack_require__.e(9189).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 1570))))))),
	4393: () => (loadSingletonVersion("default", "@angular/cdk/bidi", false, [1,17,3,10], () => (__webpack_require__.e(3680).then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 3680))))))),
	6005: () => (loadSingletonVersion("default", "@angular/cdk/a11y", false, [1,17,3,10], () => (__webpack_require__.e(9721).then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 2102))))))),
	8045: () => (loadSingletonVersion("default", "@angular/cdk/portal", false, [1,17,3,10], () => (__webpack_require__.e(6787).then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))))),
	6199: () => (loadSingletonVersion("default", "@angular/cdk/scrolling", false, [1,17,3,10], () => (__webpack_require__.e(2356).then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 9975))))))),
	8059: () => (loadSingletonVersion("default", "@angular/cdk/collections", false, [1,17,3,10], () => (__webpack_require__.e(370).then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 370))))))),
	4164: () => (loadSingletonVersion("default", "@angular/core/primitives/signals", false, [1,17,3,0], () => (__webpack_require__.e(5689).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 5689))))))),
	9044: () => (loadSingletonVersion("default", "@angular/localize", false, [1,18,0,2], () => (__webpack_require__.e(5116).then(() => (() => (__webpack_require__(/*! @angular/localize */ 5116))))))),
	765: () => (loadSingletonVersion("default", "@angular/material/core", false, [1,17,3,10], () => (__webpack_require__.e(2265).then(() => (() => (__webpack_require__(/*! @angular/material/core */ 4646))))))),
	2190: () => (loadSingletonVersion("default", "@angular/forms", false, [1,17,3,0], () => (__webpack_require__.e(2075).then(() => (() => (__webpack_require__(/*! @angular/forms */ 4456))))))),
	1864: () => (loadSingletonVersion("default", "@angular/cdk", false, [1,17,3,10], () => (__webpack_require__.e(1398).then(() => (() => (__webpack_require__(/*! @angular/cdk */ 1398))))))),
	3105: () => (loadSingletonVersion("default", "@angular/material/input", false, [1,17,3,10], () => (__webpack_require__.e(7922).then(() => (() => (__webpack_require__(/*! @angular/material/input */ 5541))))))),
	6229: () => (loadSingletonVersion("default", "@angular/material/form-field", false, [1,17,3,10], () => (__webpack_require__.e(2569).then(() => (() => (__webpack_require__(/*! @angular/material/form-field */ 4950))))))),
	6258: () => (loadSingletonVersion("default", "@angular/material/button", false, [1,17,3,10], () => (__webpack_require__.e(6556).then(() => (() => (__webpack_require__(/*! @angular/material/button */ 4175))))))),
	8010: () => (loadSingletonVersion("default", "@angular/animations", false, [1,17,3,0], () => (__webpack_require__.e(4791).then(() => (() => (__webpack_require__(/*! @angular/animations */ 7172))))))),
	3729: () => (loadSingletonVersion("default", "@angular/cdk/dialog", false, [1,17,3,10], () => (__webpack_require__.e(1101).then(() => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 3482))))))),
	8039: () => (loadSingletonVersion("default", "@angular/cdk/observers/private", false, [1,17,3,10], () => (__webpack_require__.e(996).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 8615))))))),
	5141: () => (loadSingletonVersion("default", "@angular/cdk/text-field", false, [1,17,3,10], () => (__webpack_require__.e(7559).then(() => (() => (__webpack_require__(/*! @angular/cdk/text-field */ 9940))))))),
	6972: () => (loadSingletonVersion("default", "@angular/common/http", false, [1,17,3,0], () => (__webpack_require__.e(8824).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 6443))))))),
	1929: () => (loadSingletonVersion("default", "@angular/platform-browser", false, [1,17,3,0], () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 436))))))),
	599: () => (loadSingletonVersion("default", "@ng-bootstrap/ng-bootstrap", false, [1,16,0,0], () => (__webpack_require__.e(6037).then(() => (() => (__webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ 8418))))))),
	1878: () => (loadSingletonVersion("default", "@angular/localize/init", false, [1,18,0,2], () => (__webpack_require__.e(1643).then(() => (() => (__webpack_require__(/*! @angular/localize/init */ 1643))))))),
	2209: () => (loadSingletonVersion("default", "@angular/material/card", false, [1,17,3,10], () => (__webpack_require__.e(6158).then(() => (() => (__webpack_require__(/*! @angular/material/card */ 3777))))))),
	3374: () => (loadSingletonVersion("default", "@swimlane/ngx-datatable", false, [1,20,1,0], () => (__webpack_require__.e(6222).then(() => (() => (__webpack_require__(/*! @swimlane/ngx-datatable */ 3841))))))),
	3681: () => (loadSingletonVersion("default", "@angular/material/datepicker", false, [1,17,3,10], () => (__webpack_require__.e(4358).then(() => (() => (__webpack_require__(/*! @angular/material/datepicker */ 1977))))))),
	5012: () => (loadSingletonVersion("default", "@angular/router", false, [1,17,3,0], () => (__webpack_require__.e(2691).then(() => (() => (__webpack_require__(/*! @angular/router */ 5072))))))),
	6753: () => (loadSingletonVersion("default", "@angular/material/checkbox", false, [1,17,3,10], () => (__webpack_require__.e(4643).then(() => (() => (__webpack_require__(/*! @angular/material/checkbox */ 7024))))))),
	7504: () => (loadSingletonVersion("default", "ngx-editor", false, [1,18,0,0], () => (__webpack_require__.e(4194).then(() => (() => (__webpack_require__(/*! ngx-editor */ 1813))))))),
	8537: () => (loadSingletonVersion("default", "@angular/material/dialog", false, [1,17,3,10], () => (__webpack_require__.e(4968).then(() => (() => (__webpack_require__(/*! @angular/material/dialog */ 2587))))))),
	9049: () => (loadSingletonVersion("default", "@angular/material/select", false, [1,17,3,10], () => (__webpack_require__.e(7556).then(() => (() => (__webpack_require__(/*! @angular/material/select */ 5175))))))),
	9279: () => (loadSingletonVersion("default", "@angular/material/radio", false, [1,17,3,10], () => (__webpack_require__.e(1423).then(() => (() => (__webpack_require__(/*! @angular/material/radio */ 3804))))))),
	3438: () => (loadSingletonVersion("default", "@angular/core/rxjs-interop", false, [1,17,3,0], () => (__webpack_require__.e(6693).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 9074))))))),
	7601: () => (loadSingletonVersion("default", "@popperjs/core", false, [1,2,11,8], () => (__webpack_require__.e(1280).then(() => (() => (__webpack_require__(/*! @popperjs/core */ 1280))))))),
	4986: () => (loadSingletonVersion("default", "ngx-editor/helpers", false, [1,18,0,0], () => (__webpack_require__.e(5046).then(() => (() => (__webpack_require__(/*! ngx-editor/helpers */ 2665))))))),
	3566: () => (loadSingletonVersion("default", "ngx-editor/utils", false, [1,18,0,0], () => (__webpack_require__.e(2325).then(() => (() => (__webpack_require__(/*! ngx-editor/utils */ 2325))))))),
	3996: () => (loadSingletonVersion("default", "ngx-editor/schema", false, [1,18,0,0], () => (__webpack_require__.e(1147).then(() => (() => (__webpack_require__(/*! ngx-editor/schema */ 1147))))))),
	9318: () => (loadSingletonVersion("default", "ngx-editor/commands", false, [1,18,0,0], () => (__webpack_require__.e(3947).then(() => (() => (__webpack_require__(/*! ngx-editor/commands */ 9976)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"80": [
		5880
	],
	"370": [
		5883
	],
	"432": [
		599,
		765,
		1878,
		2190,
		2209,
		3105,
		3374,
		3681,
		4606,
		5012,
		5880,
		5883,
		6229,
		6753,
		6972,
		7504,
		8537,
		9049,
		9279
	],
	"433": [
		4606
	],
	"436": [
		4606,
		5880,
		6972
	],
	"1101": [
		2115,
		4393
	],
	"1299": [
		4606,
		5880
	],
	"1423": [
		6005,
		8059
	],
	"1570": [
		2115,
		2931,
		4393,
		4606,
		5065,
		5880,
		5883,
		6199,
		6883,
		8045
	],
	"1643": [
		9044
	],
	"1813": [
		1929,
		2190,
		3566,
		3996,
		4606,
		4986,
		5880,
		5883,
		6883,
		9318
	],
	"1977": [
		765,
		1839,
		2115,
		2190,
		2931,
		3105,
		4393,
		4606,
		5065,
		5880,
		5883,
		6005,
		6199,
		6229,
		6258,
		6883,
		8010,
		8045
	],
	"2075": [
		5880,
		5883,
		6883
	],
	"2102": [
		2115,
		2931,
		4606,
		5065,
		5880,
		5883,
		6597,
		6883,
		7139
	],
	"2265": [
		1864,
		2115,
		2931,
		4393,
		5065,
		5880,
		5883,
		6005,
		6883
	],
	"2356": [
		2115,
		5065,
		8059
	],
	"2569": [
		2115,
		4393,
		5065,
		5880,
		6883,
		7139,
		8010,
		8039
	],
	"2587": [
		765,
		1839,
		2931,
		3729,
		4606,
		5065,
		5880,
		5883,
		6005,
		6883,
		8010,
		8045
	],
	"2691": [
		1929,
		6883
	],
	"3482": [
		1839,
		2115,
		2931,
		4393,
		4606,
		5880,
		5883,
		6005,
		6883,
		8045
	],
	"3528": [
		3566
	],
	"3777": [
		765,
		4606,
		5880
	],
	"3804": [
		765,
		2190,
		4606,
		5880,
		6005,
		8059
	],
	"3841": [
		4606,
		5880,
		5883,
		6883
	],
	"4175": [
		765,
		2115,
		4606,
		6005
	],
	"4194": [
		1929,
		3566,
		3996,
		4986,
		6883,
		9318
	],
	"4358": [
		1839,
		2115,
		2931,
		4393,
		5065,
		6005,
		6199,
		6258,
		6883,
		8010,
		8045
	],
	"4456": [
		4606,
		5880,
		5883,
		6883
	],
	"4646": [
		1864,
		2115,
		2931,
		4393,
		4606,
		5065,
		5880,
		5883,
		6005,
		6883
	],
	"4950": [
		765,
		2115,
		4393,
		4606,
		5065,
		5880,
		5883,
		6883,
		7139,
		8010,
		8039
	],
	"4968": [
		1839,
		2931,
		3729,
		5065,
		6005,
		6883,
		8010,
		8045
	],
	"5072": [
		1929,
		4606,
		5880,
		5883,
		6883
	],
	"5175": [
		765,
		1839,
		2190,
		2931,
		4393,
		4606,
		5880,
		5883,
		6005,
		6199,
		6229,
		6883,
		8010,
		8059
	],
	"5541": [
		765,
		2115,
		2190,
		4606,
		5065,
		5141,
		5883,
		6229
	],
	"6037": [
		3438,
		6883,
		7601
	],
	"6222": [
		6883
	],
	"6443": [
		4606,
		5880,
		5883,
		6883
	],
	"7024": [
		765,
		2190,
		4606
	],
	"7172": [
		4606,
		5880
	],
	"7556": [
		1839,
		2931,
		4393,
		6005,
		6199,
		6883,
		8010,
		8059
	],
	"7559": [
		5880,
		6883
	],
	"7580": [
		4164,
		5883,
		6883
	],
	"7699": [
		4606,
		5880
	],
	"7912": [
		2115,
		4606,
		5065,
		5883,
		6883
	],
	"7922": [
		2115,
		5065,
		5141
	],
	"7935": [
		4606
	],
	"7989": [
		4606,
		5883
	],
	"8055": [
		6972
	],
	"8418": [
		2190,
		3438,
		4606,
		5880,
		5883,
		6883,
		7601
	],
	"8615": [
		4606,
		5883,
		6883
	],
	"8824": [
		5883,
		6883
	],
	"9017": [
		4606
	],
	"9074": [
		4606,
		5883,
		6883
	],
	"9168": [
		4606,
		5880
	],
	"9189": [
		2115,
		4393,
		5065,
		6199,
		8045
	],
	"9539": [
		4606,
		5065,
		5883,
		6883
	],
	"9721": [
		2115,
		2931,
		5065,
		5880,
		5883,
		6597,
		6883,
		7139
	],
	"9940": [
		2115,
		4606,
		5065,
		5880,
		5883,
		6883
	],
	"9975": [
		2115,
		4393,
		4606,
		5065,
		5880,
		5883,
		6883,
		8059
	],
	"9976": [
		4986
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}